import { BrowserRouter, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { LangProvider, useLang } from './context/LangContext';
import Nav from './components/Nav';
import Home from './pages/Home';
import Menu from './pages/Menu';
import Reservations from './pages/Reservations';
import FlipMenu from './pages/FlipMenu';
import Admin from './pages/Admin';
import Links from './pages/Links';
import Follow from './pages/Follow';
import './styles/global.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function NotFound() {
  const { t } = useLang();
  const navigate = useNavigate();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', textAlign: 'center', padding: '4rem 2rem' }}>
      <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: '5rem', color: 'var(--charcoal)', fontWeight: 400, marginBottom: '1rem' }}>404</h1>
      <p style={{ color: 'var(--coconut)', marginBottom: '2rem' }}>{t('404.msg')}</p>
      <button className="btn-primary" onClick={() => navigate('/')}>{t('404.btn')}</button>
    </div>
  );
}

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Standalone pages — no Nav bar */}
          <Route path="/flipbook" element={<FlipMenu />} />
          <Route path="/admin"    element={<Admin />} />
          <Route path="/links"    element={<Links />} />
          <Route path="/follow"   element={<Follow />} />
          {/* All other routes get the Nav */}
          <Route path="*" element={
            <>
              <Nav />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/menu" element={<Menu />} />
                <Route path="/reservations" element={<Reservations />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </>
          } />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}
